<template>
    <div class="wrap wrap--products">
        <!-- 헤더 -->
        <main-header></main-header>

        <!-- 메인 -->
        <main class="main" role="main">
            <div class="inner">
                <div class="board">
                    <div class="center-area">
                        <center-navigation />
                        <div class="center-board">
                            <faq-list />
                        </div>
                    </div>
                </div>
            </div>
        </main>

        <!-- 푸터 -->
        <main-footer></main-footer>
    </div>
</template>

<script>
import MainHeader from "../../../components/client/inc/main-header.vue";
import MainFooter from "../../../components/client/inc/main-footer.vue";
import FaqList from "@/components/client/center/faq/faq-list.vue";
import CenterNavigation from "@/components/client/center/center-navigation.vue";

export default {
    components: {
        MainHeader,
        MainFooter,
        FaqList,
        CenterNavigation,
    },
    created() {},
    mounted() {
        this.init();
    },
    methods: {
        init: function() {
            // FAQ - 답변 토글
            (function() {
                let question = document.querySelectorAll(".board-table--faq [data-idx]");

                for (let i = 0; i < question.length; i++) question[i].addEventListener("click", toggleInquiry);

                function toggleInquiry() {
                    let idx = this.getAttribute("data-idx");

                    if (this.getAttribute("data-answer") === "opened") {
                        for (let i = 0; i < question.length; i++) question[i].removeAttribute("data-answer");
                    } else {
                        for (let i = 0; i < question.length; i++) question[i].removeAttribute("data-answer");
                        this.setAttribute("data-answer", "opened");
                    }
                }
            })();
        },
    },
};
</script>
